import dynamic from "next/dynamic";

import type { Props as AdSlotProps } from "~/components/advertisement/ad-slots/ad-slot";

export const DynamicAdSlot = dynamic<AdSlotProps>(() =>
  import("~/components/advertisement/ad-slots/ad-slot").then(module => module.AdSlot),
);
